var map = {
	"./audio.png": "0361",
	"./back.png": "ae5c",
	"./banner.png": "1936",
	"./carousel-default.png": "9150",
	"./check.png": "722d",
	"./default.png": "6bcd",
	"./defaut.png": "001f",
	"./doc.png": "af4b",
	"./file.png": "87d4",
	"./flash.png": "08f2",
	"./icon-file.png": "b790",
	"./icon-tips.png": "8c28",
	"./icon_return.png": "dbc0",
	"./image.png": "bf05",
	"./jlg_header.png": "99b8",
	"./lianxi.png": "59dd",
	"./logo.png": "9d64",
	"./message/close.png": "3c8c",
	"./message/contact.png": "1e69",
	"./message/info.png": "03a2",
	"./pdf.png": "b9de",
	"./ppt.png": "fe3e",
	"./qrcode-tips.png": "dd21",
	"./txt.png": "5c63",
	"./uncheck.png": "1018",
	"./unknown.png": "f087",
	"./video.png": "c59e",
	"./xls.png": "ffdb",
	"./zip.png": "15f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";